import { SVGProps } from 'react';

import { MbcpEmpresasLogo } from './mbcpEmpresasLogo';
import { MbcpEmpresasWhiteLogo } from './mbcpEmpresasWhiteLogo';
import { MbcpLogo } from './mbcpLogo';
import { MbcpWhiteLogo } from './mbcpWhiteLogo';

export type LogoProps = Pick<SVGProps<SVGSVGElement>, 'width' | 'height'>;

export const logos = {
	MbcpEmpresasLogo,
	MbcpEmpresasWhiteLogo,
	MbcpLogo,
	MbcpWhiteLogo,
};
